<template>
  <div row :class="ui.colorNavigationBar" v-if="true">
    <v-layout row class="ml-4">
      <div :class="ui.textSubheading">
          {{selectMessage}}
      </div>
      <div :class="ui.textSubheading">
          {{getUser.pref.select.cname}}
      </div>
      <div class="ml-1 mr-1"/>
      <div :class="ui.textSubheading" v-if="getUser.pref.select.cname !== ''">
        /
      </div>
      <div class="ml-1 mr-1" v-if="this.getUser.pref.select.fdid !== ''"/>
      <div :class="ui.textSubheading">
          {{getUser.pref.select.fname}}
      </div>
      <div class="ml-1 mr-1" v-if="this.getUser.pref.select.fdid !== ''"/>
      <div  class="hidden-xs-only"
      v-if="docInfo.idg !== '' && this.getUser.pref.select.fdid !== ''"
      > <span :class="ui.textSubheading"> / </span>

      </div>
      <div class="ml-1 mr-1"/>
      <div :class="ui.textSubheading" class="hidden-xs-only">
          {{docInfo.idg}}
      </div>
      <v-spacer/>
      <div class="ml-3 mr-4 hidden-xs-only"
      v-if="this.getDetail !== null && this.getDetail.basic.tag === 'A1'">
        <div class="mr-4">
          <span :class="ui.textSubheading">
            {{this.getDetail.basic.id}}
          </span>
        </div>
      </div>
    </v-layout>
    <v-layout row class="ml-4 mr-2">
      <v-spacer/>
      <div :class="ui.textDescriptionBkgd">
        .
      </div>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
export default {
  computed: {
    ...mapGetters(["getUser", "getDetail", "getCurrentPage"]),
    selectMessage() {
      let msg = "";
      if (this.getUser.pref.select.cname === "") {
        msg = "Business Process not Selected";
      }
      return msg;
    },
    docInfo() {
      let obj = {
        idg: ""
      };
      if (this.getDetail !== null) {
        let tag = this.getDetail.basic.tag;
        let idg = this.getDetail.basic.idg;
        if (
          tag !== "C1" &&
          tag !== "F1" &&
          this.getCurrentPage !== "/appdash" &&
          this.getCurrentPage !== "/accesslist" &&
          this.getCurrentPage !== "/companydash" &&
          this.getCurrentPage !== "/activitylog" &&
          this.getCurrentPage !== "/companydashsafety" &&
          this.getCurrentPage !== "/companydashtechnical" &&
          this.getCurrentPage !== "/companydashbusiness" &&
          this.getCurrentPage !== "/userdash"
        ) {
          obj.idg = this.displayDocumentIDGTypeA(tag, idg);
        }
      }
      return obj;
    }
  },
  mixins: [apptheme, displayFunctions]
};
</script>
